import { useRouter } from 'vue-router'

const router = useRouter()

export default function useTags(type) {
    const metadata = () => {
        if (type !== undefined && type.includes('client')) {
            // TODO: Custom here...
            return {
                title: 'Categoria de atendimentos',
                name: 'Categoria de atendimentos',
                description: 'Descriçào categoria de atendimentos',
                routerPath: 'clientTags',
                type: 'client',
            }
        }
        
        return {
            title: 'Classificação de atendimentos',
            name: 'Classificação de atendimentos',
            description: 'Gerencie tags para classificar os atendimentos, para levantar informações sobre o atendimento',
            routerPath: 'attendanceCategory',
            type: 'attendance',
        }
    }
    
    
    return { metadata }
}
